module.exports = __webpack_public_path__ + "static/media/supply chain disruptions.c96e3929.svg";